import React from 'react';

// routing
import Routes from './routes';

// project imports
import { useSelector } from 'react-redux';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, StyledEngineProvider } from '@mui/material';

// defaultTheme
import { enhancedTheme } from './themes/enhancedTheme';

// third-party
import { ApolloProvider } from '@apollo/client';
import { apolloClient } from './services/api';

// project imports
import ErrorBoundary from './Components/ErrorBoundary';
import { EmailJobProvider } from './contexts/EmailJobContext';
import EmailJobFloatingIndicator from './Components/EmailJobFloatingIndicator';

// ==============================|| APP ||============================== //

const App = () => {
    const customization = useSelector(state => state.customization);

    return (
        <ErrorBoundary>
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={enhancedTheme}>
                    <CssBaseline />
                    <ApolloProvider client={apolloClient}>
                        <EmailJobProvider>
                            <Routes />
                            <EmailJobFloatingIndicator />
                        </EmailJobProvider>
                    </ApolloProvider>
                </ThemeProvider>
            </StyledEngineProvider>
        </ErrorBoundary>
    );
};

export default App;
